export default "__VITE_ASSET__DdufVSxa__"